import { css } from "@emotion/react";
import styled from "@emotion/styled";
import ArrowDown from "@engineering/icons/arrow-down";
import ArrowUp from "@engineering/icons/arrow-up";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var cq = function(_size) {
    return "@container (min-width: 39.375rem) ";
};
var FeedbackContainer = /*#__PURE__*/ styled("div", {
    target: "e1huomwz0"
})("display:flex;flex-direction:column;column-gap:1rem;", cq("g8"), "{flex-direction:", function(props) {
    return props.hasSummary ? "row" : "column";
}, ";row-gap:1rem;}");
var SummaryContainer = /*#__PURE__*/ styled("div", {
    target: "e1huomwz1"
})(cq("g8"), "{flex:1;}");
var AverageRating = /*#__PURE__*/ styled("div", {
    target: "e1huomwz2"
})("margin-bottom:1.875rem;", cq("g8"), "{margin-bottom:0;}");
var ColoredText = /*#__PURE__*/ styled("span", {
    target: "e1huomwz3"
})("color:", function(param) {
    var theme = param.theme;
    return theme.color.primary;
}, ";");
var LocationName = /*#__PURE__*/ styled("span", {
    target: "e1huomwz4"
})("display:inline-block;margin-bottom:0.5rem;");
var ReviewListContainer = /*#__PURE__*/ styled("div", {
    target: "e1huomwz5"
})("width:100%;", cq("g8"), "{flex:1;}");
var ReviewContainer = /*#__PURE__*/ styled("div", {
    target: "e1huomwz6"
})("padding:0.5rem;border:1px solid ", function(param) {
    var theme = param.theme;
    return theme.color.natural50;
}, ";margin-bottom:", function(param) {
    var largeReview = param.largeReview;
    return largeReview ? "1rem" : "-1px";
}, ";");
var StyledHeader = /*#__PURE__*/ styled("div", {
    target: "e1huomwz7"
})("width:100%;display:inline-flex;column-gap:0.625rem;");
var ReviewFooter = /*#__PURE__*/ styled("div", {
    target: "e1huomwz8"
})("width:100%;display:inline-flex;justify-content:space-between;column-gap:0.625rem;button{padding:0.6rem;}");
var QuoteContainer = /*#__PURE__*/ styled("div", {
    target: "e1huomwz9"
})("margin:0.625rem 0;p{margin:0.3125rem 0;}");
var RatingGroupList = /*#__PURE__*/ styled("ul", {
    target: "e1huomwz10"
})("margin-top:0.625rem;background-color:", function(param) {
    var theme = param.theme;
    return theme.color.natural10;
}, ";padding:0.625rem;p{font-size:0.75rem;display:flex;column-gap:0.625rem;> span{width:35%;}}");
var RatingGroupItemCriterion = /*#__PURE__*/ styled("span", {
    target: "e1huomwz11"
})("margin-right:2.1875rem;");
var getArrowStyles = function(theme) {
    return /*#__PURE__*/ css("width:0.75rem;height:0.75rem;fill:", theme.color.primary, ";");
};
var ArrowDownIcon = /*#__PURE__*/ styled(ArrowDown, {
    target: "e1huomwz12"
})(function(param) {
    var theme = param.theme;
    return getArrowStyles(theme);
}, ";");
var ArrowUpIcon = /*#__PURE__*/ styled(ArrowUp, {
    target: "e1huomwz13"
})(function(param) {
    var theme = param.theme;
    return getArrowStyles(theme);
}, ";");
export { AverageRating, ColoredText, FeedbackContainer, LocationName, ReviewListContainer, ReviewContainer, ReviewFooter, RatingGroupList, RatingGroupItemCriterion, StyledHeader, SummaryContainer, QuoteContainer, ArrowDownIcon, ArrowUpIcon };
